import { render } from "./IndirizziSpedizione.vue?vue&type=template&id=1331bb78"
import script from "./IndirizziSpedizione.vue?vue&type=script&lang=js"
export * from "./IndirizziSpedizione.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__